module.exports = __webpack_public_path__ + "media/images/banner/marumotakagi/banner-c2606dd046c6c05ffa5c31f030d617f7.jpg";